import { PaginationType } from '@.api/methods';

export const createDefaultPagination = (): PaginationType => ({
    page: 1,
    per_page: 5,
    total: 0,
    last_page: 1,
});
